export const breadcrumbs = [
    {
        title: 'Packs'
    }
]
export const descriptions = {
    drumeo: 'Training packs help you dive deeper and build expertise in specific skills and genres, taking your drumming to the next level in particular areas you want to focus on.',
    pianote: 'Training packs help you dive deeper and build expertise in specific skills and genres, taking your piano playing to the next level in particular areas you want to focus on.',
    guitareo: 'Training packs help you dive deeper and build expertise in specific skills and genres, taking your guitar playing to the next level in particular areas you want to focus on.',
    singeo: 'Here you can access Musora training packs. If you\'ve purchased access to these packs individually you’ll have lifetime access to them. If you own a Musora Membership you\'ll have access to these packs as long as you\'re a member!',
}

export const sortOptions = [
    {
        value: '-published_on',
        name: 'Newest First',
        icon: 'sort-down'
    },
    {
        value: 'published_on',
        name: 'Oldest First',
        icon: 'sort-up'
    },
    {
        value: 'slug',
        name: 'Name: A to Z',
        icon: 'sort-name-asc'
    },
    {
        value: '-slug',
        name: 'Name: Z to A',
        icon: 'sort-name-desc'
    }
];

export const tabData =  [
    {
        value: 'All Packs',
        groupByView: false,
        key: '',
    }
];
